// frontend/modules/customer-category/index.ts
import { ModuleConfig } from '@/core/module';
import { customerCategoryRoutes } from './routes';
import { useCustomerCategoryStore } from './stores/customer-category-store';

export const CustomerCategoryModule: ModuleConfig = {
    name: 'customer-category',
    routes: customerCategoryRoutes,
    stores: {
        customerCategory: useCustomerCategoryStore
    },
    initialize: () => {
        // Customer Category module initialized
    }
};